export default __webpack_public_path__ + "static/media/home-restaurant-img-11.e0026c30.jpg";